import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { useCalculateTotal } from '../../../../hooks/useCalculateTotal';
import FormLayoutGenerator from '../../../FormLayoutGenerator';
import { useCalculatePercentage } from '../hooks/useCalculatePercentage';
import { GridCompact6 } from 'components/shared/Grid/Grid.components';
import { FIELDS } from './NonProductiveHours.consts';

const NonProductiveHours = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.surcharges'
  });

  useCalculateTotal(
    [
      'finEHolidaysPrc',
      'finESpecialleavePrc',
      'finESchoolingPrc',
      'finETrainingPrc',
      'finEFestivedaysPrc',
      'finEIllPrc',
      'finEVariousownPrc',
      'finEAgehoursPrc'
    ],
    'totalNph'
  );

  useCalculateTotal(
    [
      'finEHolidaysBuhPrc',
      'finESpecialleaveBuhPrc',
      'finESchoolingBuhPrc',
      'finETrainingBuhPrc',
      'finEFestivedaysBuhPrc',
      'finEIllBuhPrc',
      'finEVariousownBuhPrc',
      'finEAgehoursBuhPrc'
    ],
    'totalNphBuh'
  );

  useCalculatePercentage('totalNph', 'percentageUplift');
  useCalculatePercentage('totalNphBuh', 'percentageUpliftBuh');

  return (
    <>
      <GridCompact6>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t('work_header')}
        </Typography>
      </GridCompact6>
      <GridCompact6>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t('buh_header')}
        </Typography>
      </GridCompact6>
      <FormLayoutGenerator
        fieldConfigs={FIELDS}
        translateKeyPrefix="employerCostSettings"
      />
    </>
  );
};

export default NonProductiveHours;
